module.exports = __webpack_public_path__ + "img/pause_cat.4f895c85.png";